var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-double"
  }, /*#__PURE__*/React.createElement("path", {
    id: "union-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0096 7.75774C15.4001 8.14826 15.4001 8.78143 15.0096 9.17195L7.93962 16.242C7.75208 16.4295 7.49773 16.5348 7.23251 16.5348C6.96729 16.5348 6.71294 16.4295 6.5254 16.242L2.9904 12.707C2.59988 12.3164 2.59988 11.6833 2.9904 11.2927C3.38093 10.9022 4.01409 10.9022 4.40462 11.2927L7.23251 14.1206L13.5954 7.75774C13.9859 7.36721 14.6191 7.36721 15.0096 7.75774ZM21.0096 7.75774C21.4001 8.14826 21.4001 8.78143 21.0096 9.17195L13.9396 16.242C13.5491 16.6325 12.9159 16.6325 12.5254 16.242L10.9904 14.707L12.4046 13.2927L13.2325 14.1206L19.5954 7.75774C19.9859 7.36721 20.6191 7.36721 21.0096 7.75774Z",
    fill: "#198754"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDouble);
export default __webpack_public_path__ + "static/media/check-double.a63299a3853a3f904d890d4ad2837899.svg";
export { ForwardRef as ReactComponent };